<template>
    <div class="row">
        <div class="col col-12 no-print">
            <div class="my-2">
                <router-link
                    :to="{ name: 'preliminary-risk-analyses' }"
                    class="btn btn-success"
                >
                    <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
                    Voltar para AR
                </router-link>
                <button
                        class="btn btn-primary ml-3"
                        :class="{ 'btn-loading': loadingPrint }"
                        :disabled="loadingPrint"
                        @click="print"
                >
                    <span class="btn-print__spinner" v-if="loadingPrint">
                        <ProgressSpinner
                            style="width: 18px; height: 18px"
                            stroke-width="5"
                        />
                    </span>
                    <span v-if="!loadingPrint">
                        <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
                        Salvar / Imprimir
                    </span>
                </button>
            </div>
        </div>

        <div class="col-12">
            <DataTable
                    :value="machines"
                    :lazy="true"
                    :paginator="true"
                    :paginator-position="'both'"
                    :rows="99999999999"
                    :rows-per-page-options="[10, 25, 50]"
                    :total-records="totalRecords"
                    :loading="loading"
                    :row-hover="true"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                    ref="dt"
                    data-key="id"
                    class="p-datatable-gridlines p-datatable-sm"
            >
                <template #empty> Nenhum item encontrado </template>
                <template #loading> Carregando </template>
                <Column header="Foto">
                    <template #body="{ data }">
                        <img
                                class="table-image expandable-image"
                                :src="data.picture_url"
                                alt=""
                                @click="showSingleImage(data.picture_url)"
                        />
                    </template>
                </Column>
                <Column header="Identificação">
                    <template #body="{ data }">
                        <div>
                            <b>Classe Equip.:</b> {{ data.machine_class_name || '-' }}
                        </div>
                        <div><b>Tag Equip.:</b> {{ data.machine_tag }}</div>
                        <div><b>Equip. Primário:</b> {{ data.primary_machine_tag }}</div>
                        <div><b>Tag Ambra:</b> {{ data.ambra_tag }}</div>
                        <div><b>ID:</b> {{ data.id }}</div>
                        <div><b>Acompanhante:</b> {{ getAcompanhanteDisplay(data) }}</div>
                    </template>
                </Column>
                <Column header="Localização">
                    <template #body="{ data }">
                        <div><b>Área:</b> {{ data.company_area_name }}</div>
                        <div><b>Setor:</b> {{ data.company_sector_name }}</div>
                        <div><b>Complemento:</b> {{ data.company_complement_name }}</div>
                    </template>
                </Column>
                <Column header="Perigos">
                    <template #body="{ data }">
                        {{ data.natures_of_risk }}
                    </template>
                </Column>
                <Column header="Galeria" style="width: 300px">
                    <template #body="{ data }">
                        <div class="analysis-images-gallery-grid">
                            <div
                                v-for="(image, i) in getAnalysisImages(data)"
                                :key="i"
                                class="image-thumb-holder"
                            >
                                <img
                                    :src="image"
                                    alt=""
                                    class="image-thumb"
                                />
                            </div>
                        </div>
                    </template>
                </Column>
                <Column header="Não Conformidades">
                    <template #body="{ data }">
                        <table class="mb-2 inner-table hrn-level-table">
                            <tbody>
                            <tr>
                                <td
                                        :style="{ fontWeight: data.hrn_level_acceptable && 'bold' }"
                                >
                                    {{ getLevelCountValue(data.hrn_level_acceptable) }}
                                </td>
                                <td
                                        :style="{
                      backgroundColor:
                        data.hrn_level_acceptable && getHrnLevelColor(1),
                    }"
                                >
                                    Aceitável
                                </td>
                            </tr>
                            <tr>
                                <td
                                        :style="{ fontWeight: data.hrn_level_very_low && 'bold' }"
                                >
                                    {{ getLevelCountValue(data.hrn_level_very_low) }}
                                </td>
                                <td
                                        :style="{
                      backgroundColor:
                        data.hrn_level_very_low && getHrnLevelColor(2),
                    }"
                                >
                                    Muito Baixo
                                </td>
                            </tr>
                            <tr>
                                <td :style="{ fontWeight: data.hrn_level_low && 'bold' }">
                                    {{ getLevelCountValue(data.hrn_level_low) }}
                                </td>
                                <td
                                        :style="{
                      backgroundColor:
                        data.hrn_level_low && getHrnLevelColor(3),
                    }"
                                >
                                    Baixo
                                </td>
                            </tr>
                            <tr>
                                <td
                                        :style="{
                      fontWeight: data.hrn_level_significant && 'bold',
                    }"
                                >
                                    {{ getLevelCountValue(data.hrn_level_significant) }}
                                </td>
                                <td
                                        :style="{
                      backgroundColor:
                        data.hrn_level_significant && getHrnLevelColor(4),
                    }"
                                >
                                    Significante
                                </td>
                            </tr>
                            <tr>
                                <td :style="{ fontWeight: data.hrn_level_high && 'bold' }">
                                    {{ getLevelCountValue(data.hrn_level_high) }}
                                </td>
                                <td
                                        :style="{
                      backgroundColor:
                        data.hrn_level_high && getHrnLevelColor(5),
                    }"
                                >
                                    Alto
                                </td>
                            </tr>
                            <tr>
                                <td
                                        :style="{ fontWeight: data.hrn_level_very_high && 'bold' }"
                                >
                                    {{ getLevelCountValue(data.hrn_level_very_high) }}
                                </td>
                                <td
                                        :style="{
                      backgroundColor:
                        data.hrn_level_very_high && getHrnLevelColor(6),
                    }"
                                >
                                    Muito Alto
                                </td>
                            </tr>
                            <tr>
                                <td :style="{ fontWeight: data.hrn_level_extreme && 'bold' }">
                                    {{ getLevelCountValue(data.hrn_level_extreme) }}
                                </td>
                                <td
                                        :style="{
                      backgroundColor:
                        data.hrn_level_extreme && getHrnLevelColor(7),
                    }"
                                >
                                    Extremo
                                </td>
                            </tr>
                            <tr>
                                <td
                                        :style="{
                      fontWeight: data.hrn_level_unacceptable && 'bold',
                    }"
                                >
                                    {{ getLevelCountValue(data.hrn_level_unacceptable) }}
                                </td>
                                <td
                                        :class="{ unacceptable: !!data.hrn_level_unacceptable }"
                                        :style="{
                      backgroundColor:
                        data.hrn_level_unacceptable && getHrnLevelColor(8),
                    }"
                                >
                                    Inaceitável
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="total">
                            <b>Total: </b> <span>{{ data.noncompliances_total || '-' }}</span>
                        </div>
                    </template>
                </Column>
                <Column header="Risco Geral Equipamento">
                    <template #body="{ data }">
                        <table class="mb-2 inner-table" style="">
                            <thead>
                            <tr>
                                <th>PO</th>
                                <th>GPD</th>
                                <th>FE</th>
                                <th>NP</th>
                                <th>RES</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{{ data.po || '-' }}</td>
                                <td>{{ data.gpd || '-' }}</td>
                                <td>{{ data.fe || '-' }}</td>
                                <td>{{ data.np || '-' }}</td>
                                <td
                                        :class="{ unacceptable: data.hrn_level === 8 }"
                                        :style="`background-color: ${getHrnLevelColor(
                      data.hrn_level,
                    )}`"
                                        width="60px"
                                >
                                    {{ formatHrnResult(data.hrn_result) || '-' }}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <table-iso-138491 :machine-id="data.id"></table-iso-138491>

                        <table class="inner-table" v-if="isCompanyMondelez()">
                            <thead>
                            <tr>
                                <th colspan="4">Mondelez</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Sev.</td>
                                <td>{{ data.mondelez_severity || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Prob.</td>
                                <td>{{ data.mondelez_probability || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Res.</td>
                                <td
                                        :style="{
                      backgroundColor:
                        data.mondelez_result &&
                        getMondelezLevelColor(data.mondelez_result),
                    }"
                                >
                                    {{ data.mondelez_result || '-' }} ({{
                                    data.mondelez_result_label || '-'
                                    }})
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>

<script>
    import { computed, defineAsyncComponent } from 'vue'
    import { useStore } from 'vuex'

    import DataTable from 'primevue/datatable'
    import Column from 'primevue/column'

    import { MONDELEZ_ID } from '@/constants/config.constants.js'

    import useHrn from '@/modules/Hrn.js'
    import useMondelez from '@/modules/Mondelez.js'
    import useImageViewer from '@/modules/ImageViewer.js'
    import { useRouter, useRoute } from 'vue-router'

    import ProgressSpinner from 'primevue/progressspinner'

    const TableIso138491 = defineAsyncComponent({
        loader: () =>
            import('@/components/risk-analyses/components/TableIso138491.vue'),
    })

    export default {
        setup() {
            const store = useStore()
            const route = useRoute()
            const router = useRouter()
            const selected_company = computed(() => store.getters.selected_company)
            const selected_order_of_service = computed(() => store.getters.selected_order_of_service)
            const { getHrnLevelColor } = useHrn()
            const { getMondelezLevelColor } = useMondelez()
            const { showImageIndex, showSingleImage } = useImageViewer()
            let { filters } = route.params

            try {
                filters = JSON.parse(filters)
            } catch (ex) {
                console.log('Error parsing printing filters...')
                filters = {}
            }

            return {
                selected_company,
                selected_order_of_service,
                getHrnLevelColor,
                getMondelezLevelColor,
                showImageIndex,
                showSingleImage,
                filters,
                router,
            }
        },
        components: {
            DataTable,
            Column,
            TableIso138491,
            ProgressSpinner
        },
        data() {
            return {
                machines: [],
                totalRecords: 0,
                lazyParams: {},
                loading: true,
                loadingPrint: false
            }
        },
        mounted() {
            this.lazyParams = {
                first: 0,
                rows: -1,
                sortField: null,
                sortOrder: null
            }

            this.loadLazyData()
        },
        methods: {
            loadLazyData(page = 1) {
                var app = this
                this.loading = true

                const queryString = this.getQueryString(page, this.lazyParams.rows)

                if (this.selected_order_of_service.id) {
                    app.axios
                        .get(
                            `/api/machines/all?order_of_service_id=${this.selected_order_of_service.id}${queryString}`,
                        )
                        .then(({ data }) => {
                            app.machines = data.data
                            this.totalRecords = data.total
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                        .finally(() => {
                            app.loading = false
                        })
                }
            },
            getQueryString(page, perPage) {
                let query = ''

                if (page) query += `&page=${page}`

                if (perPage) query += `&perPage=${perPage}`

                if (this.filters) {
                    const queryStringFilters = Object.keys(this.filters)
                        .filter((key) => this.filters[key])
                        .map((key) => key + '=' + this.filters[key])
                        .join('&')

                    query += `&${queryStringFilters}`
                }

                return query
            },
            formatHrnResult(hrn) {
                const hrnFormatted = parseFloat(hrn).toFixed(3)
                if (isNaN(hrnFormatted)) return ''
                return hrnFormatted
            },
            getLevelCountValue(levelCount) {
                return !isNaN(levelCount) ? levelCount : '-'
            },
            // Mesma lógica de MachineHeader.vue (acompanhanteDisplay), adaptada
            // para o resultado "achatado" desta listagem (data.acompanhante_json
            // vem direto do JOIN com orders_of_service, não de uma relation).
            getAcompanhanteDisplay(data) {
                const raw = data?.acompanhante_json

                if (!raw) return '-'

                try {
                    const list = typeof raw === 'string' ? JSON.parse(raw) : raw

                    if (!Array.isArray(list) || !list.length) return '-'

                    const names = list
                        .map((item) =>
                            typeof item === 'string'
                                ? item
                                : item?.nome || item?.name || '',
                        )
                        .filter(Boolean)

                    return names.length ? names.join(', ') : '-'
                } catch (e) {
                    return '-'
                }
            },
            getAnalysisImages(data) {
                let images = data?.analysis_pictures?.split(',')
                images = images.map(image => data.server_url + image)

                if (!images) return []

                return images
            },
            isCompanyMondelez() {
                return this.selected_company.id === MONDELEZ_ID
            },
            onPage(event) {
                this.lazyParams = event

                const { page } = event

                this.loadLazyData(page + 1)
            },
            print() {
                if (this.loadingPrint) return

                this.loadingPrint = true

                Promise.all(
                    Array.from(document.images)
                        .filter((img) => !img.complete)
                        .map(
                            (img) =>
                                new Promise((resolve) => {
                                    img.onload = img.onerror = resolve
                                }),
                        ),
                ).then(() => {
                    console.log('images finished loading')
                    this.loadingPrint = false
                    window.print()
                })
            },

        },
        watch: {
            selected_company() {
                this.loadLazyData()
            },
        },
    }
</script>

<style lang="scss" scoped>
    .table-image {
        max-width: 80px;
        max-height: 100px;
        object-fit: cover;
    }

    .unacceptable {
        color: #fff;
    }

    .inner-table,
    td,
    td {
        border: 1px solid #ccc;
        border-collapse: collapse;
    }

    .inner-table thead {
        background-color: #eaeaea;
    }

    .hrn-level-table {
        min-width: 120px;
        width: auto !important;

        td {
            padding: 5px;
        }
    }

    .expandable-image {
        cursor: pointer;
    }

    .analysis-images-gallery-grid {
        display: grid;
        grid-template-columns: 60px 60px 60px 60px 60px;
        gap: 5px;

        .image-thumb-holder {
            width: 60px;
            height: 60px;
            display: inline-block;

            .image-thumb {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
</style>
